import React, { useState } from "react";
import { alpha, IconButton, Stack } from "@mui/material";
import { Eye } from "iconsax-react";
import { grey } from "@mui/material/colors";
import TicketDetailsDialog from "../TicketDetailsDialog";

export default function TicketsTableActions({ ticket, fetchTickets }) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  
  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: "4px",
      }}
    >
      <TicketDetailsDialog
        open={openDialog}
        ticket={ticket}
        onClose={handleDialogClose}
      />
      <IconButton
        size="small"
        aria-label="Ver información del ticket"
        onClick={handleDialogOpen}
        style={{
          color: grey[500],
          backgroundColor: alpha(grey[500], 0.1),
        }}
      >
        <Eye variant="Outline" size={20} fontSize="small" />
      </IconButton>
    </Stack>
  );
}

